import React from 'react';
import styled from 'styled-components';
import { SlidePage } from '../index';
import { BodyContainer } from '../styles';
import KnowledgeAreasChart from '../KnowledgeAreasChart';
import { getDimensionFullName } from '../constants';
import icono from '../imgs/icons/edu_iconos_binoculars.svg';

export const ChartWrapper = styled.div`
  margin-top: -16px;
  margin-bottom: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 220px;
  width: 100%;
`;

const VocationOneKnowledgeAreasGraphPage = ({
  user,
  background,
  number,
  isLast
}) => {
  const { TOP_DIM_1, TOP_DIM_2, FIRST_AREA_ITEMS, SECOND_AREA_ITEMS } = user;
  // console.log({ TOP_DIM_1, TOP_DIM_2 });
  const firstDimName = getDimensionFullName(TOP_DIM_1);
  const secondDimName = getDimensionFullName(TOP_DIM_2);
  return (
    <SlidePage number={number} background={background}>
      <BodyContainer>
        <div className='content'>
          <h2>2.4. Áreas de conocimiento</h2>
          <p className='justified'>
            Las Áreas de Conocimiento son agrupaciones o grandes familias de
            profesiones que son similares (por ejemplo, ciencias sociales,
            salud, tecnología, etc.). Tus preferencias vocacionales pueden
            desplegarse mejor en algunas de estas áreas que en otras, por lo que
            Vocation One evalúa cuáles áreas de conocimiento más relacionadas
            con tus dos o tres preferencias principales te resultarían más
            atractivas.
          </p>

          <p className='justified'>
            En la figura de más abajo verás tu nivel de interés por las áreas de
            conocimiento que se relacionan más directamente con tu preferencia
            por actividades de <strong>{firstDimName}</strong>
          </p>

          <ChartWrapper>
            <KnowledgeAreasChart
              user={user}
              order='FIRST'
              areas={FIRST_AREA_ITEMS.map(area =>
                area.replace('_FIRST_SUM', '')
              )}
            />
          </ChartWrapper>

          <p className='justified' style={{ marginTop: -10, marginBottom: 6 }}>
            En la figura de más abajo verás tu nivel de interés en las áreas de
            conocimiento que se relacionan más directamente con tu preferencia
            por actividades de <strong>{secondDimName}</strong>
          </p>

          <ChartWrapper>
            <KnowledgeAreasChart
              user={user}
              order='SECOND'
              areas={SECOND_AREA_ITEMS.map(area =>
                area.replace('_SECOND_SUM', '')
              )}
            />
          </ChartWrapper>

          {isLast && (
            <div style={{ position: 'relative' }}>
              <div style={{ position: 'absolute', top: -45, left: -25 }}>
                <img
                  src={icono}
                  alt='icono binoculares'
                  style={{ width: 100, height: 'auto' }}
                />
              </div>
              <div className='edu-bubble-group bg-edu-red'>
                <p className='justified'>
                  El test evalúa por separado tu nivel de interés en las áreas
                  académicas relacionadas con tus dos o tres preferencias
                  principales. Por eso, puede ocurrir que una o más áreas de
                  conocimiento se repitan entre los gráficos, pero con puntajes
                  diferentes. Esto no es un error: refleja que tu interés por
                  una misma área puede ser más alto cuando se compara con
                  ciertas alternativas, y más bajo cuando se compara con otras.{' '}
                  <strong>
                    Revisar ambos gráficos en conjunto te permitirá tener una
                    visión más completa de las áreas que te atraen, y en qué
                    contextos se conectan mejor con tus intereses.
                  </strong>
                </p>
              </div>
            </div>
          )}

          {/* <p className='justified small'>
            <em>Nota. </em>
            Los resultados anteriores muestran en qué área académica te
            resultaría más atractivo trabajar para desplegar cada una de tus
            preferencias vocacionales prioritarias. Por esto, si bien un área
            académica puede resultarte poco interesante al relacionarla con una
            de tus preferencias prioritarias, esta misma área puede ser más
            interesante al relacionarla con otra de tus áreas de preferencia (o
            viceversa).
          </p> */}
        </div>
      </BodyContainer>
    </SlidePage>
  );
};

export default VocationOneKnowledgeAreasGraphPage;
